import { createContext } from 'react';

const YoutrackIssuesSelectedContext = createContext({ services: [] });

export default YoutrackIssuesSelectedContext;
